<template>
  <el-dialog
    title="PDF预览"
    width="900px"
    top="50px"
    append-to-body
    :visible.sync="dialogFormVisible"
    custom-class="upload-dialog"
  >
    <div class="flex-center">
      <embed :src="src" width="860px" height="600px" />
    </div>
    <div slot="footer" class="flex-center">
      <el-button type="primary" @click="dialogFormVisible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name:'PdfPreview',
  props: {
    show: {
      type: Boolean,
    },
    src: {
      type: String,
      default:
        "http://testapi.frippler.cn/attachment/docus/0/2022/10/e5eSwstHR86aagZg16eqG1h1166MSV.pdf",
    },
  },
  computed: {
    dialogFormVisible: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
};
</script>